export default __webpack_public_path__ + "static/media/secondary.8e4292bfa81f5b4ef35087a78fadfe01.svg";